<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <componentheader :title="title" />

        <div class="row">
          <div class="col-md-12">
            <div class="card-body">
              <div class="form-group-item">
                <h5 class="form-title">Basic Details</h5>
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Item Type</label>
                      <input
                        type="text"
                        class="form-control"
                        value="Product"
                        placeholder="Enter Item Name"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        class="form-control"
                        value="Lorem ipsum dolor sit"
                        placeholder="Enter Item Name"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Item Category</label>
                      <input
                        type="text"
                        class="form-control"
                        value="Duis aute irure"
                        placeholder="Enter Category Name"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Price</label>
                      <input
                        type="number"
                        class="form-control"
                        value="253.00"
                        placeholder="Enter Item Price"
                        name="name"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Units</label>
                      <input
                        type="text"
                        class="form-control"
                        value="Inches"
                        placeholder="Enter Units"
                        name="name"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group-item">
                <div class="form-group">
                  <h5 class="form-title">Additional Details</h5>
                </div>
                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div class="form-group">
                      <label>Generate Barcode</label>
                      <input
                        type="text"
                        class="form-control"
                        value="P125389"
                        placeholder="Enter Barcode Number"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div class="form-group">
                      <label>Purchase Price Without Tax</label>
                      <input
                        type="text"
                        class="form-control"
                        value="$00.00"
                        placeholder="Enter Address 1"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div class="form-group">
                      <label>Purchase Price With Tax</label>
                      <input
                        type="text"
                        class="form-control"
                        value="$253.00"
                        placeholder="Enter Tax Amount"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div class="form-group">
                      <label>Quantity</label>
                      <input
                        type="text"
                        class="form-control"
                        value="2"
                        placeholder="eg 10"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                    <div class="form-group" id="summernote_container">
                      <label class="form-control-label">Details</label>
                      <SummernoteEditor
                        v-model="myValue"
                        @update:modelValue="summernoteChange($event)"
                        @summernoteImageLinkInsert="summernoteImageLinkInsert"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                    <div class="form-group">
                      <label>Image</label>
                      <div class="form-group service-upload mb-0">
                        <span
                          ><img src="@/assets/img/icons/drop-icon.svg" alt="upload"
                        /></span>
                        <h6 class="drop-browse align-center">
                          Drop your files here or<span class="text-primary ms-1"
                            >browse</span
                          >
                        </h6>
                        <p class="text-muted">Maximum size: 50MB</p>
                        <input type="file" multiple="" id="image_sign" />
                        <div id="frames"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group-item border-0 pb-0">
                <div class="form-group">
                  <h5 class="form-title">Discount Details</h5>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Discount (%)</label>
                      <ul class="form-group-plus css-equal-heights">
                        <li>
                          <vue-select :options="Percentage" placeholder="5%" />
                        </li>
                        <li>
                          <span class="btn btn-gray form-plus-btn">%</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Discount Amount</label>
                      <input
                        type="text"
                        class="form-control"
                        value="$10.00"
                        placeholder="Enter Discount Amount"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Minimum Stock Qty</label>
                      <input
                        type="text"
                        class="form-control"
                        value="2"
                        placeholder="eg 10"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-end">
                <button type="reset" class="btn btn-primary cancel me-2">Cancel</button>
                <b-button type="submit" variant="primary">Add Item</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>

<script>
import SummernoteEditor from "vue3-summernote-editor";
export default {
  components: {
    SummernoteEditor,
  },
  data() {
    return {
      Percentage: ["5%", "10%", "15%"],
      myValue: "",
      title: "Edit Products / Services",
    };
  },
  methods: {
    summernoteChange(newValue) {
      console.log("summernoteChange", newValue);
    },
    summernoteImageLinkInsert(...args) {
      console.log("summernoteImageLinkInsert()", args);
    },
  },
};
</script>
